module.exports = __webpack_public_path__ + "src/assets/games/42/195.jpg";